import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    List,
    Placeholder
} from "semantic-ui-react";

const Publications = ({ authorId }) => {
    const [papers, setPapers] = useState(null);
    const [paperCount, setPaperCount] = useState(3);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchS2Papers() {
            const authorUrl = `https://api.semanticscholar.org/v1/author/${authorId}`;
            try {
                const { data: authorData } = await axios.get(authorUrl);
                setPaperCount(authorData.papers.length);
                const papersByYear = authorData.papers.sort((a, b) => b.year - a.year);
                const paperQueries = papersByYear.map(async (paper) => {
                    const paperUrl = `https://api.semanticscholar.org/v1/paper/${paper.paperId}`;
                    const { data: paperData } = await axios.get(paperUrl);
                    const authors = paperData.authors.map(author => {
                        const [first, ...last] = author.name.split(" ");
                        const initial = first[0];
                        const lastname = last[last.length - 1];
                        return `${initial}. ${lastname}`;
                    });
                    return { ...paper, authors };
                });
                const papers = await Promise.all(paperQueries);
                setPapers(papers);
            } catch (error) {
                setError(error);
            }
        }
        fetchS2Papers();
    }, [authorId]);

    if (!papers) {
        return (
            <Placeholder fluid>
                {Array.from(Array(paperCount)).map((_, i) => (
                    <div key={i}>
                        <Placeholder.Line length="full" />
                        <Placeholder.Line length="full" />
                        <Placeholder.Line length="very short" />
                    </div>
                ))}
            </Placeholder>
        );
    }

    if (error) {
        return (
            <i>Error loading contributions: {error}</i>
        );
    }

    return (
        <List>
            {papers.map(paper => (
                <List.Item key={paper.paperId}>
                    <div><a href={paper.url}>{paper.title}</a></div>
                    <div><i>{paper.authors.join(", ")}</i></div>
                    <div>{paper.year}</div>
                </List.Item>
            ))}
        </List>
    );
};

export default Publications;